import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../shared/services/auth.service';
@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor( 
    private http: HttpClient, 
    private auth: AuthService,
    @Inject(LOCALE_ID) private locale: string
     ) {}
  
  async getCultureId(){
    switch (this.locale) {
      case 'en':
        return 1

      case 'sv':
        return 2

      case 'cs':
        return 3

      case 'es':
        return 4
        
      case 'nb':
        return 5

      case 'de':
        return 6

      case 'da':
        return 7

      case 'fr':
        return 8

      case 'sk':
        return 9

      case 'hu':
        return 10
      default:
        return 1
    }
  }
  async getArticles(){
    let culture_id = await this.getCultureId();
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}article/${culture_id}`, httpOptions).toPromise()
  }

 async getArticleById(id){
    const token = await this.auth.getToken();
    let culture_id = await this.getCultureId();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}article/${id}/${culture_id}`, httpOptions).toPromise()
  }

  async getArticleAttributes(article_id: any){
    let culture_id = await this.getCultureId();
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}article/attributes/${article_id}/${culture_id}`, httpOptions).toPromise()
  }

  async getArticleAttributeValues(article_id: any){
    
    let culture_id = await this.getCultureId();
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}article/attributes/value/${article_id}/${culture_id}`, httpOptions).toPromise()
  }

  async getPaperPrices(){
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}article/paperprice`, httpOptions).toPromise()
  }
  async getCurrencyRate(currency){
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get(`${environment.api_url}article/price/${currency}`, httpOptions).toPromise()
  }
}
